var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"install-control"},[_c('button',{staticClass:"btn btn-success",on:{"click":_vm.send}},[_vm._v("\n      "+_vm._s(_vm._f("setText")("next_step","Далее"))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }